// import { useState } from 'react';

// interface LikertInputProps {
//   disabled: boolean;
// }

// export const LikertInput = ({ disabled }: LikertInputProps) => {
//   const [value, setValue] = useState<number | null>(null);
//   const [hover, setHover] = useState<number | null>(null);
//   const labels = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'];

//   return (
//     <div className="space-y-4">
//       {/* Horizontal connected scale */}
//       <div className="relative px-4">
//         {/* Connection line */}
//         <div className="absolute top-1/2 left-4 right-4 h-0.5 bg-gray-300 -translate-y-1/2" />

//         {/* Circles */}
//         <div className="relative flex justify-between">
//           {labels.map((label, i) => (
//             <button
//               key={i}
//               type="button"
//               disabled={disabled}
//               onClick={() => !disabled && setValue(i)}
//               onMouseEnter={() => !disabled && setHover(i)}
//               onMouseLeave={() => !disabled && setHover(null)}
//               className="flex flex-col items-center group"
//             >
//               <div
//                 className={`w-8 h-8 rounded-full border-2 transition-all duration-200 ${
//                   i <= (hover ?? value ?? -1)
//                     ? 'border-[#C0275E] bg-[#C0275E]'
//                     : 'border-gray-300 bg-white'
//                 } ${!disabled ? 'group-hover:scale-110' : ''}`}
//               >
//                 <div
//                   className={`w-full h-full rounded-full flex items-center justify-center text-xs font-bold transition-colors ${
//                     i <= (hover ?? value ?? -1) ? 'text-white' : 'text-gray-400'
//                   }`}
//                 >
//                   {i + 1}
//                 </div>
//               </div>
//               <span
//                 className={`mt-2 text-xs text-center max-w-[60px] transition-colors ${
//                   i === (hover ?? value) ? 'text-[#C0275E] font-medium' : 'text-gray-500'
//                 }`}
//               >
//                 {label}
//               </span>
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Selected value display */}
//       {value !== null && (
//         <div className="text-center p-2 bg-pink-50 rounded-lg border border-pink-200">
//           <span className="text-sm text-[#621C43] font-medium">
//             Selected: {labels[value]} ({value + 1}/5)
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

import { Check } from 'lucide-react';
import { useState } from 'react';

interface LikertInputProps {
  disabled?: boolean;
}

export const LikertInput = ({ disabled = false }: LikertInputProps) => {
  const [value, setValue] = useState<number | null>(0); // default first selected like image

  const labels = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly agree'];

  return (
    <div className="w-full max-w-3xl mx-auto">
      {/* Scale Container */}
      <div className="relative flex items-center justify-between px-6">
        {/* Background Line */}
        <div className="absolute left-6 right-6 h-[2px] bg-[#C9A8B8]" />

        {labels.map((label, i) => {
          const selected = value === i;

          return (
            <button
              key={i}
              type="button"
              disabled={disabled}
              onClick={() => !disabled && setValue(i)}
              className="relative z-10 flex flex-col items-center"
            >
              {/* Circle */}
              <div
                className={`w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all
                ${selected ? 'bg-[#6A1B3F] border-[#6A1B3F]' : 'bg-white border-[#6A1B3F]'}
                ${!disabled ? 'hover:scale-105' : ''}
              `}
              >
                {selected && <Check size={16} className="text-white" />}
              </div>
            </button>
          );
        })}
      </div>

      {/* Labels */}
      <div className="flex justify-between px-2 mt-4 text-sm text-[#6A1B3F]">
        {labels.map((label, i) => (
          <div key={i} className="text-center w-20">
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};
